// TODO: this is garbage
const urlRegex = new RegExp(
	'^(https?:\\/\\/)?' + // validate protocol
		'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // validate domain name
		'((\\d{1,3}\\.){3}\\d{1,3}))' + // validate OR ip (v4) address
		'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // validate port and path
		'(\\?[;&a-z\\d%_.~+=-]*)?' + // validate query string
		'(\\#[-a-z\\d_]*)?$',
	'i',
);

export const validateURL = (url: string) => {
	if (!url || url === '') return true;
	return urlRegex.test(url) ? true : new Error('invalid url');
};

export default validateURL;
